import { Outlet } from 'react-router-dom';
import styled from 'styled-components';

const LayoutContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: ${({ theme }) => theme.colors.surface};
`;

const Main = styled.main`
  flex: 1;
  width: 100%;
  // max-width: 1200px;
  margin: 0 auto;
  // padding: ${({ theme }) => theme.spacing.xl};

  @media (max-width: 768px) {
    padding: ${({ theme }) => theme.spacing.xs};
  }
`;

export const MainLayout = () => {
  return (
    <LayoutContainer>
      <Main>
        <Outlet />
      </Main>
    </LayoutContainer>
  );
};
